import script from "./CampoData.vue?vue&type=script&setup=true&lang=js"
export * from "./CampoData.vue?vue&type=script&setup=true&lang=js"

import "./CampoData.vue?vue&type=style&index=0&id=1175dfa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1175dfa4"]])

export default __exports__